import { useEffect } from 'react';

import { vendorsApi } from 'src/app/services/Vendors/Vendors.service';
import { Layout, NotFound } from 'src/components/base';
import { LoadingOverlay } from 'src/components/base/LoadingOverlay/LoadingOverlay';
import { VendorLeadSteps } from 'src/components/vendors/steps/VendorLeadSteps';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';
import { useVendorsContextCreator } from 'src/pages/VendorsPage/VendorsPage.context.hooks';

type VendorsPageProps = {
  vendorProductLeadId: string;
};

export function VendorsPage({ vendorProductLeadId }: Readonly<VendorsPageProps>) {
  const vendorsContext = useVendorsContextCreator();

  const [
    {
      data: initialVendorProductLeadData,
      loading: isInitialVendorProductLeadDataLoading,
      error: initialVendorProductLeadDataError,
    },
  ] = vendorsApi.useGetVendorProductLeadQuery(vendorProductLeadId);

  // biome-ignore lint/correctness/useExhaustiveDependencies: false
  useEffect(() => {
    if (initialVendorProductLeadData) {
      vendorsContext.updateVendorLeadProduct(initialVendorProductLeadData);
    }
  }, [initialVendorProductLeadData]);

  return (
    <VendorsContext.Provider value={vendorsContext}>
      <Layout>
        <LoadingOverlay
          className="flex-1 flex column nowrap justify-content-start align-items-stretch"
          isFirstLoading={isInitialVendorProductLeadDataLoading}
          indicatorSize={64}
        >
          {initialVendorProductLeadDataError ? (
            <NotFound />
          ) : (
            <VendorLeadSteps vendorProductLeadId={vendorProductLeadId} />
          )}
        </LoadingOverlay>
      </Layout>
    </VendorsContext.Provider>
  );
}
